import { render } from "./PrivacyPolicy.vue?vue&type=template&id=59413bfe&scoped=true"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=59413bfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59413bfe"]])

export default __exports__